// extracted by mini-css-extract-plugin
module.exports = {"wordsLeft":"words-left_wordsLeft__SbTx_"};